import gql from 'graphql-tag'
import candidateFragment from './CandidateFragment'

export const CANDIDATES_QUERY = gql`
  query Candidates {
    candidates: candidates {
      ...${candidateFragment}
    }
  }
`